import { createQueryKeys } from '@lukemorales/query-key-factory';

export const application = createQueryKeys('application', {
  choices: null,
  all: null,
  userAll: null,
  create: null,
  addUrl: null,
  addFile: null,
  retrieve: (applicationId: string) => [applicationId],
  update: (applicationId: string) => [applicationId],
  updateBeneficiary: (applicationId: string) => [applicationId],
  submit: (applicationId: string) => [applicationId],
  urls: (applicationId: string) => [applicationId],
  urlDestroy: (applicationId: string, urlId: string) => [applicationId, urlId],
  files: (applicationId: string) => [applicationId],
  fileDestroy: (applicationId: string, urlId: string) => [applicationId, urlId],
});

export const applicationEditors = createQueryKeys('applicationEditor', {
  choices: null,
  all: null,
  retrieve: (applicationEditorId: string) => [applicationEditorId],
  update: (applicationEditorId: string) => [applicationEditorId],
});
